import api from "./api";

/**
 * Service for interacting with material-related API endpoints.
 */
export const materialService = {
  /**
   * Get all materials (public)
   * @returns {Promise<Array>} List of materials
   */
  getAllMaterials: async () => {
    const response = await api.get("/materials");
    // Backend returns { status, results, data: { materials } }
    return response.data.data.materials;
  },

  /**
   * Get a material by its ID (public)
   * @param {string} id - Material ID
   * @returns {Promise<Object>} Material object
   */
  getMaterialById: async (id) => {
    const response = await api.get(`/materials/${id}`);
    // Backend returns { status, data: { material } }
    return response.data.data.material;
  },

  /**
   * Get materials by category (public)
   * @param {string} category - Category name
   * @returns {Promise<Array>} List of materials in the category
   */
  getMaterialsByCategory: async (category) => {
    const response = await api.get(`/materials/category/${category}`);
    return response.data.data.materials;
  },

  /**
   * Create a new material (admin only)
   * @param {Object} materialData - Material data
   * @returns {Promise<Object>} Created material
   */
  createMaterial: async (materialData) => {
    const response = await api.post("/materials", materialData);
    return response.data.data.material;
  },

  /**
   * Update a material by ID (admin only)
   * @param {string} id - Material ID
   * @param {Object} materialData - Updated data
   * @returns {Promise<Object>} Updated material
   */
  updateMaterial: async (id, materialData) => {
    const response = await api.patch(`/materials/${id}`, materialData);
    return response.data.data.material;
  },

  /**
   * Delete a material by ID (admin only)
   * @param {string} id - Material ID
   * @returns {Promise<void>}
   */
  deleteMaterial: async (id) => {
    await api.delete(`/materials/${id}`);
  },
};
